import SingleInputSelect from './SingleInputSelect'

export default SingleInputSelect
